/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_National_IdInputs */

const vi_grower_national_id = /** @type {(inputs: Grower_National_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số CCCD`)
};

/**

* @param {Grower_National_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_national_id = /** @type {((inputs?: Grower_National_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_National_IdInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_national_id(inputs)
});